export const sheets = ($http: HttpApi) => ({
  get: (sheetId: string, params: HttpParams['params'] = {}) => $http.$get(`/sheets/${sheetId}`, { params }),
  update: (sheetId: string, data: HttpParams['body'] = {}) => $http.$patch(`/sheets/${sheetId}`, { body: data }),
  delete: (sheetId: string) => $http.$delete(`/sheets/${sheetId}`),
  archive: (sheetId: string) => $http.$post(`/sheets/${sheetId}/archive`),
  unarchive: (sheetId: string) => $http.$delete(`/sheets/${sheetId}/archive`),
});
